import React, { useState } from "react";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Nav from "./components/Nav";
import Home from "./pages/Home";
import LoadingScreen from "./components/LoadingScreen";
import logo from "./Assets/logo.png";
import AboutUs from "pages/AboutUs";
import EarlyAccess from "pages/EarlyAccess";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

function App() {
  const [loadingComplete, setLoadingComplete] = useState(false);

  return (
    <HelmetProvider>
      <>
        <ToastContainer position="top-right" autoClose={3000} />
        {!loadingComplete && <LoadingScreen logo={logo} duration={800} onComplete={() => setLoadingComplete(true)} />}
        {loadingComplete && (
          <>
            
            <Router>
              <div className="app-wrapper">
                <Nav />
                <div className="routes-container">
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about_us" element={<AboutUs />} />
                    <Route path="/early_access" element={<EarlyAccess />} />
                  </Routes>
                </div>
              </div>
            </Router>
          </>
        )}
      </>
    </HelmetProvider>
  );
}

export default App;
